import { render, staticRenderFns } from "./broadcasterChannelMappingList.vue?vue&type=template&id=6a58b904&scoped=true"
import script from "./broadcasterChannelMappingList.vue?vue&type=script&lang=js"
export * from "./broadcasterChannelMappingList.vue?vue&type=script&lang=js"
import style0 from "./broadcasterChannelMappingList.vue?vue&type=style&index=0&id=6a58b904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58b904",
  null
  
)

export default component.exports